<div class="carousel-viewport">
  <div class="tile-track" (transitionend)="finalizeMove()"
    [style.transition]="isAnimating() ? 'transform 0.5s ease-in-out' : 'none'" [style.transform]="transformStyle()">

    @for (item of items(); track item.id) {
    <!-- <div class="tile">{{ item.url }}</div> -->
    <div class="tile"><img [ngSrc]="item.img.src" [alt]="item.img.alt" [title]="item.img.alt"  [fill]="useFill()" [class]="item.img.class"  [sizes]="item.sizes"  [loading]="item.img.loading"
        [style.object-position]="item.img.objectPosition ?? 'center'" [priority]="item.img.priority"
        (click)="toggleAutoPlay($event)" (keydown.enter)="toggleAutoPlay($event)"
        (keydown.space)="toggleAutoPlay($event)"  (touchstart)="swipe($event, 'start')" (touchend)="swipe($event, 'end')"
        tabindex="0" role="button"
        [attr.aria-label]="autoPlayEnabled() ? 'Autoplay pausieren' : 'Autoplay starten'"
        [placeholder]="usePlaceholder()" [loaderParams]="{filters: 'quality(' + quality() + ')', repo: repo()}">
    </div>
    }
  </div>
  <div class="carousel-button-previous">
    <button type="button" matMiniFab (click)="movePrev($event)"
      aria-label="Zurück"><mat-icon>chevron_left</mat-icon></button>
  </div>
  <div class="carousel-button-next">
    <button type="button" matMiniFab (click)="moveNext($event)"
      aria-label="Vorwärts"><mat-icon>chevron_right</mat-icon></button>
  </div>
  @if (!autoPlayEnabled()) {
  <div class="carousel-button-play">
    <button type="button" matMiniFab (click)="toggleAutoPlay($event)"
      aria-label="Autoplay fortsetzen"><mat-icon>play_arrow</mat-icon></button>
  </div>
  }
  @if(!disablePagination()) {
  <div class="carousel-pagination">
    <ul class="carousel-pagination-list">
      @for (tile of tiles(); track tile; let idx = $index) {
      <li [class.active]="idx === currentIndex()" (click)="goToIndex($event, idx)"
        (keydown.enter)="goToIndex($event, idx)" (keydown.space)="goToIndex($event, idx)" tabindex="0" role="button"
        [attr.aria-label]="`Springe zu Bild ${idx}`">
      </li>
      }
    </ul>
  </div>
}
</div>